export default {
  version: 8,
  glyphs: '/assets/fonts/pbf/{fontstack}/{range}.pbf',
  name: 'protomaps-themes-base/light-customised',
  sources: {
    protomaps: {
      type: 'vector',
      tiles: ['https://api.protomaps.com/tiles/v2/{z}/{x}/{y}.pbf'],
      minzoom: 0,
      maxzoom: 14,
      attribution:
        '<a href="https://protomaps.com" target="_blank">Protomaps</a> © <a href="https://www.openstreetmap.org" target="_blank"> OpenStreetMap</a>'
    }
  },
  layers: [
    {
      id: 'background',
      type: 'background',
      paint: {
        'background-color': '#f2f2f2'
      }
    },
    {
      id: 'earth',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'earth',
      paint: {
        'fill-color': '#f2f2f2'
      }
    },
    {
      id: 'landuse_park',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'landuse',
      filter: [
        'any',
        ['==', 'pmap:kind', 'park'],
        ['==', 'landuse', 'cemetery']
      ],
      paint: { 'fill-color': '#f9f9f9' }
    },
    {
      id: 'landuse_hospital',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'landuse',
      filter: ['any', ['==', 'pmap:kind', 'hospital']],
      paint: { 'fill-color': '#f2f2f2' }
    },
    {
      id: 'landuse_industrial',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'landuse',
      filter: ['any', ['==', 'pmap:kind', 'industrial']],
      paint: { 'fill-color': '#f2f2f2' }
    },
    {
      id: 'landuse_school',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'landuse',
      filter: ['any', ['==', 'pmap:kind', 'school']],
      paint: { 'fill-color': '#f2f2f2' }
    },
    {
      id: 'landuse_pedestrian',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'landuse',
      filter: ['any', ['==', 'highway', 'footway']],
      paint: {
        'fill-color': '#f2f2f2'
      }
    },
    {
      id: 'water',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'water',
      paint: {
        'fill-color': '#c8e5f3'
      }
    },
    {
      id: 'roads_tunnels_other_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['<', 'pmap:level', 0], ['==', 'pmap:kind', 'other']],
      paint: {
        'line-color': '#ffffff',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          14,
          0,
          14.5,
          0.5,
          20,
          12
        ]
      }
    },
    {
      id: 'roads_tunnels_other',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['<', 'pmap:level', 0], ['==', 'pmap:kind', 'other']],
      paint: {
        'line-color': '#f7f7f7',
        'line-dasharray': [1, 1],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          14,
          0,
          14.5,
          0.5,
          20,
          12
        ]
      }
    },
    {
      id: 'roads_tunnels_minor_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['<', 'pmap:level', 0],
        ['==', 'pmap:kind', 'minor_road']
      ],
      paint: {
        'line-color': '#e2e2e2',
        'line-dasharray': [3, 2],
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          0.5,
          20,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          1
        ]
      }
    },
    {
      id: 'roads_tunnels_minor',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['<', 'pmap:level', 0],
        ['==', 'pmap:kind', 'minor_road']
      ],
      paint: {
        'line-color': '#ebebeb',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          0.5,
          20,
          32
        ]
      }
    },
    {
      id: 'roads_tunnels_medium_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['<', 'pmap:level', 0],
        ['==', 'pmap:kind', 'medium_road']
      ],
      paint: {
        'line-color': '#e1e1e1',
        'line-dasharray': [3, 2],
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          0.5,
          20,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          10,
          0,
          10.5,
          1
        ]
      }
    },
    {
      id: 'roads_tunnels_medium',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['<', 'pmap:level', 0],
        ['==', 'pmap:kind', 'medium_road']
      ],
      paint: {
        'line-color': '#ebebeb',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          0.5,
          20,
          32
        ]
      }
    },
    {
      id: 'roads_tunnels_major_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['<', 'pmap:level', 0],
        ['==', 'pmap:kind', 'major_road']
      ],
      paint: {
        'line-color': '#e8e8e8',
        'line-dasharray': [3, 2],
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          0.5,
          19,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          9,
          0,
          9.5,
          1
        ]
      }
    },
    {
      id: 'roads_tunnels_major',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['<', 'pmap:level', 0],
        ['==', 'pmap:kind', 'major_road']
      ],
      paint: {
        'line-color': '#ebebeb',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          0.5,
          19,
          32
        ]
      }
    },
    {
      id: 'roads_tunnels_highway_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['<', 'pmap:level', 0], ['==', 'pmap:kind', 'highway']],
      paint: {
        'line-color': '#e8e8e8',
        'line-dasharray': [3, 2],
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          3,
          0,
          3.5,
          0.5,
          18,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          1
        ]
      }
    },
    {
      id: 'roads_tunnels_highway',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['<', 'pmap:level', 0], ['==', 'pmap:kind', 'highway']],
      paint: {
        'line-color': '#ebebeb',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          3,
          0,
          3.5,
          0.5,
          18,
          32
        ]
      }
    },
    {
      id: 'physical_line_waterway',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'physical_line',
      filter: ['==', ['get', 'pmap:kind'], 'waterway'],
      paint: {
        'line-color': '#c8e5f3',
        'line-width': 0.5
      }
    },
    {
      id: 'buildings',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'buildings',
      filter: [
        '!',
        [
          'in',
          ['get', 'name'],
          ['literal', ['Gallery of Modern Art', 'Queensland Art Gallery']]
        ]
      ],
      paint: {
        'fill-color': '#e8e8e8',
        'fill-outline-color': '#d4d4d4'
      }
    },
    {
      id: 'roads_other',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['==', 'pmap:level', 0], ['==', 'pmap:kind', 'other']],
      paint: {
        'line-color': '#ffffff',
        'line-dasharray': [2, 1],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          14,
          0,
          14.5,
          0.5,
          20,
          12
        ]
      }
    },
    {
      id: 'roads_minor_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['==', 'pmap:level', 0],
        ['==', 'pmap:kind', 'minor_road']
      ],
      paint: {
        'line-color': '#e2e2e2',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          0.5,
          20,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          1
        ]
      }
    },
    {
      id: 'roads_minor',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['==', 'pmap:level', 0],
        ['==', 'pmap:kind', 'minor_road']
      ],
      paint: {
        'line-color': 'white',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          0.5,
          20,
          32
        ]
      }
    },
    {
      id: 'roads_medium_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['==', 'pmap:level', 0],
        ['==', 'pmap:kind', 'medium_road']
      ],
      paint: {
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          10,
          0.75,
          18,
          2
        ],
        'line-color': 'rgb(232, 232, 232)',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          5,
          0.1,
          18,
          26
        ]
      }
    },
    {
      id: 'roads_medium',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['==', 'pmap:level', 0],
        ['==', 'pmap:kind', 'medium_road']
      ],
      paint: {
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          5,
          0.1,
          18,
          26
        ],
        'line-color': 'rgb(255, 255, 255)'
      }
    },
    {
      id: 'roads_major',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['==', 'pmap:level', 0],
        ['==', 'pmap:kind', 'major_road']
      ],
      paint: {
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          5,
          0.75,
          18,
          32
        ],
        'line-color': 'rgb(255, 255, 255)'
      }
    },
    {
      id: 'roads_highway_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['==', 'pmap:level', 0], ['==', 'pmap:kind', 'highway']],
      paint: {
        'line-color': '#e8e8e8',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          3,
          0,
          3.5,
          0.5,
          18,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          1
        ]
      }
    },
    {
      id: 'roads_highway',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['==', 'pmap:level', 0], ['==', 'pmap:kind', 'highway']],
      paint: {
        'line-color': '#fefffc',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          3,
          0,
          3.5,
          0.5,
          18,
          32
        ]
      }
    },
    {
      id: 'transit_railway',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'transit',
      filter: ['all', ['==', 'pmap:kind', 'railway']],
      paint: {
        'line-color': 'rgb(218, 218, 218)',
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          14,
          0.5,
          20,
          1
        ]
      }
    },
    {
      id: 'transit_railway_tracks',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'transit',
      filter: ['all', ['==', 'pmap:kind', 'railway']],
      paint: {
        'line-color': 'rgb(218, 218, 218)',
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          14,
          4,
          20,
          8
        ],
        'line-dasharray': [0.1, 15],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 13.75, 0, 14, 1]
      }
    },
    {
      id: 'physical_line_waterway_label',
      type: 'symbol',
      source: 'protomaps',
      'source-layer': 'physical_line',
      minzoom: 14,
      layout: {
        'symbol-placement': 'line',
        'text-font': ['Flama Book'],
        'text-field': ['get', 'name'],
        'text-size': 16
      },
      paint: {
        'text-color': '#6d9db6'
      }
    },
    {
      id: 'roads_bridges_other_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['>', 'pmap:level', 0], ['==', 'pmap:kind', 'other']],
      paint: {
        'line-color': '#ffffff',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          14,
          0,
          14.5,
          0.5,
          20,
          12
        ]
      }
    },
    {
      id: 'roads_bridges_other_fill',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['>', 'pmap:level', 0], ['==', 'pmap:kind', 'other']],
      paint: {
        'line-color': '#f2f2f2',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          14,
          0,
          14.5,
          10,
          20,
          24
        ]
      }
    },
    {
      id: 'roads_bridges_other',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['>', 'pmap:level', 0], ['==', 'pmap:kind', 'other']],
      paint: {
        'line-color': '#ffffff',
        'line-dasharray': [2, 1],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          14,
          0,
          14.5,
          0.5,
          20,
          12
        ]
      }
    },
    {
      id: 'roads_bridges_minor_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['>', 'pmap:level', 0],
        ['==', 'pmap:kind', 'minor_road']
      ],
      paint: {
        'line-color': '#e2e2e2',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          0.5,
          20,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          1
        ]
      }
    },
    {
      id: 'roads_bridges_minor',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['>', 'pmap:level', 0],
        ['==', 'pmap:kind', 'minor_road']
      ],
      paint: {
        'line-color': 'white',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          12,
          0,
          12.5,
          0.5,
          20,
          32
        ]
      }
    },
    {
      id: 'roads_bridges_medium_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['>', 'pmap:level', 0],
        ['==', 'pmap:kind', 'medium_road']
      ],
      paint: {
        'line-color': '#e1e1e1',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          0.5,
          20,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          10,
          0,
          10.5,
          1
        ]
      }
    },
    {
      id: 'roads_bridges_medium',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['>', 'pmap:level', 0],
        ['==', 'pmap:kind', 'medium_road']
      ],
      paint: {
        'line-color': '#ffffff',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          0.5,
          20,
          32
        ]
      }
    },
    {
      id: 'roads_bridges_major_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['>', 'pmap:level', 0],
        ['==', 'pmap:kind', 'major_road']
      ],
      paint: {
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          10,
          ['match', ['get', 'class'], 'primary', 1, 0.75],
          18,
          2
        ],
        'line-color': 'rgb(232, 232, 232)',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          5,
          ['match', ['get', 'class'], 'primary', 0.75, 0.1],
          18,
          ['match', ['get', 'class'], 'primary', 32, 26]
        ],
        'line-opacity': ['step', ['zoom'], 0, 10, 1]
      }
    },
    {
      id: 'roads_major_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['==', 'pmap:level', 0],
        ['==', 'pmap:kind', 'major_road']
      ],
      paint: {
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          10,
          1,
          18,
          2
        ],
        'line-color': 'rgb(232, 232, 232)',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          5,
          0.75,
          18,
          32
        ]
      }
    },
    {
      id: 'roads_bridges_major',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: [
        'all',
        ['>', 'pmap:level', 0],
        ['==', 'pmap:kind', 'major_road']
      ],
      layout: { 'line-cap': ['step', ['zoom'], 'butt', 14, 'round'] },
      paint: {
        'line-width': [
          'interpolate',
          ['exponential', 1.5],
          ['zoom'],
          5,
          ['match', ['get', 'class'], 'primary', 0.75, 0.1],
          18,
          ['match', ['get', 'class'], 'primary', 32, 26]
        ],
        'line-color': 'rgb(255, 255, 255)'
      }
    },
    {
      id: 'roads_bridges_highway_casing',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['>', 'pmap:level', 0], ['==', 'pmap:kind', 'highway']],
      paint: {
        'line-color': '#e8e8e8',
        'line-gap-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          3,
          0,
          3.5,
          0.5,
          18,
          32
        ],
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          7,
          0,
          7.5,
          1
        ]
      }
    },
    {
      id: 'roads_bridges_highway',
      type: 'line',
      source: 'protomaps',
      'source-layer': 'roads',
      filter: ['all', ['>', 'pmap:level', 0], ['==', 'pmap:kind', 'highway']],
      paint: {
        'line-color': '#fefffc',
        'line-width': [
          'interpolate',
          ['exponential', 1.6],
          ['zoom'],
          3,
          0,
          3.5,
          0.5,
          18,
          32
        ]
      }
    },
    {
      id: 'roads_labels',
      type: 'symbol',
      source: 'protomaps',
      'source-layer': 'roads',
      layout: {
        'symbol-placement': 'line',
        'text-font': ['Flama Book'],
        'text-field': ['get', 'name'],
        'text-size': 14
      },
      paint: {
        'text-color': '#797979',
        'text-halo-color': 'white',
        'text-halo-width': 2
      }
    },
    {
      id: 'mask',
      type: 'fill',
      source: 'protomaps',
      'source-layer': 'mask',
      paint: {
        'fill-color': '#dddddd'
      }
    },
    {
      id: 'physical_point_ocean',
      type: 'symbol',
      source: 'protomaps',
      'source-layer': 'physical_point',
      filter: ['any', ['==', 'place', 'sea'], ['==', 'place', 'ocean']],
      layout: {
        'text-font': ['Flama Book'],
        'text-field': ['get', 'name'],
        'text-size': 14,
        'text-letter-spacing': 0.15
      },
      paint: {
        'text-color': 'white',
        'text-halo-color': '#a4cae1',
        'text-halo-width': 1
      }
    },
    {
      id: 'places_subplace',
      type: 'symbol',
      source: 'protomaps',
      'source-layer': 'places',
      filter: ['==', 'pmap:kind', 'neighbourhood'],
      layout: {
        'text-field': '{name}',
        'text-font': ['Flama Book'],
        'text-size': {
          base: 1.2,
          stops: [
            [11, 10],
            [14, 12]
          ]
        },
        'text-transform': 'uppercase'
      },
      paint: {
        'text-color': '#757d91',
        'text-halo-color': 'white',
        'text-halo-width': 0.5
      }
    },
    {
      id: 'places_city_circle',
      type: 'circle',
      source: 'protomaps',
      'source-layer': 'places',
      filter: ['==', 'pmap:kind', 'city'],
      paint: {
        'circle-radius': 2,
        'circle-stroke-width': 2,
        'circle-stroke-color': 'white',
        'circle-color': '#666666'
      },
      maxzoom: 8
    },
    {
      id: 'places_city',
      type: 'symbol',
      source: 'protomaps',
      'source-layer': 'places',
      filter: ['==', 'pmap:kind', 'city'],
      layout: {
        'text-field': '{name}',
        'text-font': ['Flama Medium'],
        'text-size': ['step', ['get', 'pmap:rank'], 0, 1, 12, 2, 10],
        'text-variable-anchor': ['bottom-left'],
        'text-radial-offset': 0.2
      },
      paint: {
        'text-color': '#787878',
        'text-halo-color': 'white',
        'text-halo-width': 1
      }
    }
  ]
};
